/**
* In this file we handel to navigation for Add Physician, Add Parent and Add Hospital Screens
**/
import { Modal, Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

/**
 * NavigationModal Component
 * A reusable modal for confirming navigation actions with dynamic messages.
 * It provides 'Yes' and 'No' buttons for user interaction.
 */
const NavigationModal = ({ show, onHide, message, onYes, onNo }) => {
    const role = Number(localStorage.getItem('role'));
    const { t } = useTranslation();
  return (
    <Modal show={show} onHide={onHide} backdrop="static">
      <Modal.Header closeButton={false} className={`${role===4?'admin-modal-header':''}`}>
        <Modal.Title>{t('modal.mapping')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" className={`${role === 4 ? 'btn-tmAquaDgreen' : ''}`} onClick={onNo}>
          {t('modal.no')}
        </Button>
        <Button variant="primary" className={`${role === 4 ? 'btn-tmAquaGreen' : ''}`} onClick={onYes}>
          {t('modal.yes')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default NavigationModal;
